import { render, staticRenderFns } from "./pending_tests.vue?vue&type=template&id=54f6cb27&scoped=true&"
import script from "./pending_tests.vue?vue&type=script&lang=js&"
export * from "./pending_tests.vue?vue&type=script&lang=js&"
import style0 from "./pending_tests.vue?vue&type=style&index=0&id=54f6cb27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f6cb27",
  null
  
)

export default component.exports